/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  CreateEstimationItemAssumptionRequest,
  EstimationItemAssumptionResponse,
  UpdateEstimationItemAssumptionRequest,
  V1EstimationItemsAssumptionsCreateError,
  V1EstimationItemsAssumptionsDeleteError,
  V1EstimationItemsAssumptionsDetailError,
  V1EstimationItemsAssumptionsListError,
  V1EstimationItemsAssumptionsUpdateError,
} from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class EstimationItemAssumption<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags EstimationItemAssumption
   * @name V1EstimationItemsAssumptionsDetail
   * @request GET:/api/v1/estimation-items/assumptions/{assumptionId}
   * @secure
   * @response `200` `EstimationItemAssumptionResponse` OK
   * @response `401` `NoContentResult` Unauthorized
   * @response `404` `ProblemDetailsWithErrorCode` Not Found
   * @response `500` `ProblemDetailsWithErrorCode` Internal Server Error
   */
  v1EstimationItemsAssumptionsDetail = (assumptionId: string, params: RequestParams = {}) =>
    this.http.request<EstimationItemAssumptionResponse, V1EstimationItemsAssumptionsDetailError>({
      path: `/api/v1/estimation-items/assumptions/${assumptionId}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags EstimationItemAssumption
   * @name V1EstimationItemsAssumptionsUpdate
   * @request PUT:/api/v1/estimation-items/assumptions/{assumptionId}
   * @secure
   * @response `200` `EstimationItemAssumptionResponse` OK
   * @response `400` `ProblemDetailsWithErrorCode` Bad Request
   * @response `401` `NoContentResult` Unauthorized
   * @response `404` `ProblemDetailsWithErrorCode` Not Found
   * @response `500` `ProblemDetailsWithErrorCode` Internal Server Error
   */
  v1EstimationItemsAssumptionsUpdate = (
    assumptionId: string,
    data: UpdateEstimationItemAssumptionRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<EstimationItemAssumptionResponse, V1EstimationItemsAssumptionsUpdateError>({
      path: `/api/v1/estimation-items/assumptions/${assumptionId}`,
      method: 'PUT',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags EstimationItemAssumption
   * @name V1EstimationItemsAssumptionsDelete
   * @request DELETE:/api/v1/estimation-items/assumptions/{assumptionId}
   * @secure
   * @response `204` `void` No Content
   * @response `401` `NoContentResult` Unauthorized
   * @response `404` `ProblemDetailsWithErrorCode` Not Found
   * @response `500` `ProblemDetailsWithErrorCode` Internal Server Error
   */
  v1EstimationItemsAssumptionsDelete = (assumptionId: string, params: RequestParams = {}) =>
    this.http.request<void, V1EstimationItemsAssumptionsDeleteError>({
      path: `/api/v1/estimation-items/assumptions/${assumptionId}`,
      method: 'DELETE',
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags EstimationItemAssumption
   * @name V1EstimationItemsAssumptionsList
   * @request GET:/api/v1/estimation-items/{estimationItemId}/assumptions
   * @secure
   * @response `200` `(EstimationItemAssumptionResponse)[]` OK
   * @response `401` `NoContentResult` Unauthorized
   * @response `404` `ProblemDetailsWithErrorCode` Not Found
   * @response `500` `ProblemDetailsWithErrorCode` Internal Server Error
   */
  v1EstimationItemsAssumptionsList = (estimationItemId: string, params: RequestParams = {}) =>
    this.http.request<EstimationItemAssumptionResponse[], V1EstimationItemsAssumptionsListError>({
      path: `/api/v1/estimation-items/${estimationItemId}/assumptions`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags EstimationItemAssumption
   * @name V1EstimationItemsAssumptionsCreate
   * @request POST:/api/v1/estimation-items/{estimationItemId}/assumptions
   * @secure
   * @response `200` `EstimationItemAssumptionResponse` OK
   * @response `400` `ProblemDetailsWithErrorCode` Bad Request
   * @response `401` `NoContentResult` Unauthorized
   * @response `404` `ProblemDetailsWithErrorCode` Not Found
   * @response `500` `ProblemDetailsWithErrorCode` Internal Server Error
   */
  v1EstimationItemsAssumptionsCreate = (
    estimationItemId: string,
    data: CreateEstimationItemAssumptionRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<EstimationItemAssumptionResponse, V1EstimationItemsAssumptionsCreateError>({
      path: `/api/v1/estimation-items/${estimationItemId}/assumptions`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
}
